import { ENV_TYPE } from '@/types';

function domainWithProtocol(domain?: string): string {
  const protocol = process.env.NODE_ENV === ENV_TYPE.DEVELOPMENT ? 'http' : 'https';

  return domain ? `${protocol}://${domain}` : '';
}

export default domainWithProtocol;
